const common = {
  'nav.home': 'Accueil',
  'nav.guide': 'Guide d\'achat',
  'nav.categories': 'Catégories',
  'nav.visitMain': 'Visiter le site principal',

  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.es': 'Español',
  'lang.pl': 'Polski',

  'category.shoes': 'Chaussures',
  'category.hoodies': 'Hoodies & Sweats',
  'category.tshirts': 'T-Shirts',
  'category.jackets': 'Vestes',
  'category.pants': 'Pantalons & Shorts',
  'category.headwear': 'Couvre-chefs',
  'category.sets': 'Ensembles',
  'category.underwear': 'Sous-vêtements',
  'category.jersey': 'Maillots',
  'category.accessories': 'Accessoires',
  'category.bags': 'Sacs',
  'category.belts': 'Ceintures',
  'category.perfumes': 'Parfums',
  'category.other': 'Autres articles',

  'footer.tagline': 'Un centre de ressources USFans indépendant.',
  'footer.quickLinks': 'Liens rapides',
  'footer.categoriesTitle': 'Catégories',
  'footer.legal': 'Mentions légales',
  'footer.disclaimerTitle': 'Avertissement',
  'footer.disclaimerText': 'USFansLink est une ressource d\'information indépendante. Nous ne garantissons pas l\'exactitude, la sécurité ni la légitimité de chaque vendeur tiers, lien, entrée de feuille de calcul, coupon ou code de réduction. Vérifiez toujours les informations de manière indépendante.',
  'footer.rights': 'Tous droits réservés.',
};

export default common;